import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { LarkErrorNavTracker } from '@/components/lark/LarkErrorNavTracker';
import { LarkErrorSheet } from '@/components/lark/LarkErrorSheet';
import { AppRoutes } from '@/routes';
import EngineDebugPanel from '@/components/EngineDebugPanel';
import { StagingRibbon } from '@/components/StagingRibbon';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <LarkErrorNavTracker />
        <ErrorBoundary>
          <TooltipProvider>
            <NotificationProvider>
              <StagingRibbon />
              <div className='min-h-screen bg-background'>
                <AppRoutes />
                <EngineDebugPanel />
              </div>
            </NotificationProvider>
          </TooltipProvider>
        </ErrorBoundary>
        <Toaster />
        <LarkErrorSheet />
      </Router>
    </ThemeProvider>
  );
}

export default App;
